import { useEffect, useRef } from 'react';

import { useCheckoutContext } from '@zooplus/checkout-state';
import { Alert } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/use-translations';
import { CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';

import styles from './api-error-message.module.scss';

const ApiErrorMessage = () => {
  const { t } = useTranslation();
  const { hasError } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const errorRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (hasError && errorRef.current) {
      errorRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      errorRef.current.focus();
    }
  }, [hasError]);

  if (!hasError) {
    return null;
  }

  return (
    <div
      ref={errorRef}
      tabIndex={-1}
      id="api-error-message-container"
      className={styles.errorContainer}
      data-testid="api-error-message">
      <Alert closeButtonAriaLabel="dismiss message" variant="error">
        {t('cart.error.api')}
      </Alert>
    </div>
  );
};

export default ApiErrorMessage;
